import { render } from "./TeleconsultationLayout.vue?vue&type=template&id=80d49908&lang=true"
import script from "./TeleconsultationLayout.vue?vue&type=script&lang=js"
export * from "./TeleconsultationLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__